import { render } from "./RouteShow.vue?vue&type=template&id=6f46c695&ts=true"
import script from "./RouteShow.vue?vue&type=script&lang=ts"
export * from "./RouteShow.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__